import React from 'react'
import { StyledDiv } from './styled'

const MiddleCenter = props => (
    <StyledDiv>
        {props.children}
    </StyledDiv>
)

export default MiddleCenter



// WEBPACK FOOTER //
// ./src/hoc/MiddleCenter/index.js